<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Заказ шашлыка</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">Иногда так хочется вкусного сочного шашлыка, но нет времени и возможности выехать за город. Ваши желания исполнит сервис доставки еды <router-link to="/">хочу-поесть.рф</router-link>. Не стоит отказывать себе в удовольствии.</p>
            <h2 style="margin-top:2%;">Доставка шашлыка</h2>
            <p>Шашлык доставляется в специальных контейнерах, что гарантирует то, что на Вашем столе окажется вкуснейшее горячее мясо только что снятое с мангала.</p>
            <p>Сказать что это вкусно – значит, ничего не сказать! Это великолепно!</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/barbecue1.jpg" alt="Заказ шашлыка" width="700" /></center></p>
            <p style="margin-top:2%;">Как удивятся Ваши гости или коллеги на корпоративе, когда увидят настоящий вкуснейший шашлык. Удивляйте! Делитесь приятными эмоциями и впечатлениями!</p>
            <p>Закажите шашлык заранее и его привезут к определенному времени. Выбирайте – шашлык из свинины, баранины, шашлык из курицы и рыбы. Лучшие шашлычники города в Вашем распоряжении.</p>
            <p>Не забудьте заказать соус и напитки.</p>
            <p style="margin-top:2%;">А для тех, кто любит готовить сам, мы приготовили подборку лучших рецептов маринада для шашлыка и рассказываем секреты его жарки.</p>
            <router-link :to="'/product/4'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'barbecue'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/barbecue.vue